import React from 'react'
import "./footer.css"

export default function Footer() {
  return (
    <div className='emas__footer'>
      <div>
        <a href='../Publications'>Market Commentary</a>
      </div>
      <div>
        <a href='../Contact-Us'>Contact Us</a>
      </div>
      <div>
        <a href='../Dashboard'>Client Portal</a>
      </div>
      <div>
        <a href='../About-Us'>About Us</a>
      </div>
    </div>
  )
}
